import React from 'react';
import { defaultArgs } from './constants';
import { FooterLayout } from '@jbhi-fi/components/src/FooterLayout';
import { NavItem } from '@jbhi-fi/components/src/FooterLayout/types';
import he from 'he';
import { getFooterNavData } from './utils/getFooterNavData';

export const Footer = () => {
  const { footerNav, footerSocials, footerLegals, footerPayments } = getFooterNavData() || {};

  if (!footerNav?.navOptions?.length) {
    return null;
  }

  const privacyLink = footerLegals?.legalsLinks?.find(
    (navItem: NavItem) => navItem.label.toLowerCase() === 'privacy policy'
  )?.url;

  return (
    <FooterLayout
      subscribeProps={{ ...defaultArgs.subscribeProps, privacyLink }}
      navigationProps={footerNav?.navOptions?.length ? footerNav : undefined}
      socialsProps={footerSocials?.socialsLinks?.length ? footerSocials : undefined}
      paymentOptionsProps={footerPayments?.paymentOptions?.length ? footerPayments : undefined}
      legalsProps={footerLegals?.legalsLinks?.length ? footerLegals : undefined}
      tagline={he.decode(window.Jbhifi.tagline || '')}
    />
  );
};
